import { Button, Card, Flex, Form, InputNumber, Select, Space, Spin, Switch, Typography } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { PERMISSIONS } from "../../../constants/permission";
import { useHasPermission } from "../../../hooks/useHasPermission";
import { useMessageApi } from "../../../context/MessageContext";
import { useEffect, useState } from "react";
import { SystemDefaultServices } from "../../../services/system-default";
import { formatDateDDMMYYYY_HHMMSS } from "../../../utils/helper";

const { Text, Link } = Typography;

const GeneralSettingPage = () => {
  const hasSystemDefaultEditor = useHasPermission([PERMISSIONS.SYSTEM_DEFAULT_EDITOR]);
  const [form] = Form.useForm();
  const messageApi = useMessageApi();
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState<any>(null);

  const fetchMasterData = async () => {
    setLoadingScreen(true);
    try {
      const dataApi = await SystemDefaultServices.getDefaultTermsRule({ type: "GENERAL_SETTING" }).then(
        (res) => res?.data || {}
      );
      setRecord(dataApi);
      form.setFieldsValue({
        noDayBeforeDueDate: dataApi?.noDayBeforeDueDate ?? 0,
        isShowReview: dataApi?.isShowReview ?? false,
        isAutomationAce: dataApi?.isAutomationAce ?? true,
      });
    } catch (error) {
      console.error("Error fetching master data:", error);
      messageApi.error("Failed to load master data.");
    } finally {
      setLoadingScreen(false);
    }
  };

  useEffect(() => {
    fetchMasterData();
  }, []);

  const handleSubmitAll = async () => {
    try {
      setLoading(true);
      const value = await form.validateFields();

      const payload = {
        ...value,
      };

      const response: any = await SystemDefaultServices.updateSystemDefaultGeneralSetting(payload);
      if (response.success) {
        messageApi.success(response.message);
      }
    } catch (err: any) {
      messageApi.error(err?.message || "Submission failed.");

      if (err.errorCode === "AUTO_ACE_FEED_ERROR") {
        form.setFieldsValue({
          isAutomationAce: false,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  if (loadingScreen) {
    return (
      <Flex gap="middle" vertical style={{ padding: "2rem" }}>
        <Spin size="large" />
      </Flex>
    );
  }

  return (
    <Form
      form={form}
      initialValues={{
        noDayBeforeDueDate: 0,
        isShowReview: false,
        isAutomationAce: true,
      }}
    >
      {hasSystemDefaultEditor ? (
        <Flex gap={16} style={{ marginBottom: 15 }} justify="end">
          <Button type="primary" onClick={handleSubmitAll} loading={loading}>
            Save
          </Button>
        </Flex>
      ) : null}
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical gap={16}>
          <Form.Item
            label="Generates export file by selected days before Due date"
            name="noDayBeforeDueDate"
            rules={[{ required: true, message: "" }]}
          >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label="Turn On Reviewed check:" name="isShowReview" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="Switching ACE Feed automatic schedule" name="isAutomationAce">
            <Select style={{ width: 240 }}>
              <Select.Option value={true}>Auto import</Select.Option>
              <Select.Option value={false}>Manual import</Select.Option>
            </Select>
          </Form.Item>
        </Flex>
        {/* LAST IMPORT STATUS */}
        {record?.feedSuccessId && (
          <Card style={{ background: "#f9fafb", marginTop: 8, padding: 16 }}>
            <Text strong style={{ color: "#888" }}>
              LAST IMPORT STATUS
            </Text>
            <Flex align="center" gap={8} style={{ marginTop: 8 }}>
              <CheckCircleFilled style={{ color: "#52c41a", fontSize: 22 }} />
              <Text>
                Last file imported successfully: <Link href="javascript;">{record?.fileNameAce}</Link>
                <span style={{ marginLeft: 8, color: "#888" }}>
                  {formatDateDDMMYYYY_HHMMSS(record?.successDateAce)}
                </span>
              </Text>
            </Flex>
          </Card>
        )}
      </Space>
    </Form>
  );
};

export default GeneralSettingPage;
